//import qs from "";
import axios from "axios";
import util from "../../../util";

const login = ({commit}, payload) => {
  var url = 'oauth/token'
  //var data = qs.stringify({'grant_type': 'password', 'username': payload.credentials.username, 'password': payload.credentials.password,withCredentials: true})
  //console.log(data)

  const params = new URLSearchParams();
  params.append('grant_type', 'password');
  params.append('username', payload.credentials.username);
  params.append('password', payload.credentials.password);

  let encoded = btoa("webapp:filekom2018");
  var headers = {
    'Authorization': 'Basic ' + encoded,
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json'
  }

  return new Promise((resolve, reject) => {
    const loadingComponent = payload.context.$loading.open()

    const axiosLogin = axios.create({
      baseURL: payload.context.$endpoint,
      timeout: 10000,
    })

    axiosLogin.post(url, params, {headers})
      .then((response) => {
        localStorage.setItem("token", response.data.access_token);
        commit('setToken', {token: response.data.access_token});

        //Cargando Data Inicial en cache
        payload.context.axios.post('/initialData/' + util.getAuth().idClient, {}, {'headers': util.getAuthHeader()}).then((response) => {

          localStorage.setItem("users", JSON.stringify(response.data.users))
          localStorage.setItem("user", JSON.stringify(response.data.user))
          localStorage.setItem("categories", JSON.stringify(response.data.categories))
          localStorage.setItem("client", JSON.stringify(response.data.client))
          localStorage.setItem("parametros", JSON.stringify(response.data.parametros))
          localStorage.setItem("departaments", JSON.stringify(response.data.departaments))
          localStorage.setItem("provinces", JSON.stringify(response.data.provinces))
          localStorage.setItem("districts", JSON.stringify(response.data.districts))

          commit('setUser', response.data.user)
          commit('setClient', response.data.client);

          loadingComponent.close()
          resolve();
        }).catch(error => {
          loadingComponent.close()
          reject(error.response)
        });

      })
      .catch((error) => {
        loadingComponent.close()
        if (error.response.status === '400')
          util.showDialogError(payload.context, 'Usuario y contraseña incorrectos.')
        else util.showDialogError(payload.context, 'Ocurrió un error al iniciar sesión.')

        reject(error.response)
      });

  });
};

const logout = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    localStorage.removeItem("token");
    commit('removeToken');
    localStorage.removeItem("users")
    localStorage.removeItem("user")
    localStorage.removeItem("categories")
    localStorage.removeItem("client")
    localStorage.removeItem("parametros")
    payload.context.$router.push({name: 'login'})
    resolve()
  })
};

const updateUser = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    payload.context.axios.post('/updateUser', payload.user, {'headers': util.getAuthHeader()}).then((response) => {
      commit('setUser', response.data)
      localStorage.setItem("user", JSON.stringify(response.data))

      resolve();
    }).catch(error => {
      reject(error.response)
    });

  })
};

const changePassword = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    payload.context.axios.put(`/users/${payload.idUser}/changePass`, payload.form, {'headers': util.getAuthHeader()}).then((response) => {
      resolve(response.data);

    }).catch(error => {
      payload.context.$dialog.alert({
        title: 'Error',
        message: error.response.data.message,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      })
      reject(error.response)
    });

  })
};

const setUser = ({commit}, payload) => {
  commit('setUser', payload)
}

export default {
  login,
  logout,
  updateUser,
  setUser,
  changePassword
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js